import { motion } from 'motion/react';
import styles from './NavigationBar.module.css';

import { Icon } from '../icon/Icon';

export function NavigationBar(props: NavigationBarProps) {
	const { onNextClick, onPrevClick, disable, labels } = props;

	const classNames = props.classNames || [];
	classNames.unshift(styles['navigation-bar']);

	const prevLabel = labels?.prevLabel || 'Previous';
	const nextLabel = labels?.prevLabel || 'Next';

	const animations = {
		hover: {
			scale: 1.1,
		},
		tap: {
			scale: 0.8,
		},
	};

	const iconColor = '#333';

	return (
		<div data-component={'navigation-bar'} className={classNames.join(' ')}>
			{disable.left ? (
				<motion.button title={prevLabel} type="button" disabled>
					<Icon name={'arrow-left'} color={iconColor} />
				</motion.button>
			) : (
				// eslint-disable-next-line react/react-in-jsx-scope
				<motion.button
					title={prevLabel}
					type="button"
					whileHover={animations.hover}
					whileTap={animations.tap}
					onClick={() => {
						onPrevClick();
					}}
				>
					<Icon name={'arrow-left'} color={iconColor} />
				</motion.button>
			)}
			{disable.right ? (
				<motion.button title={nextLabel} type="button" disabled>
					<Icon name={'arrow-right'} color={iconColor} />
				</motion.button>
			) : (
				<motion.button
					type="button"
					title={nextLabel}
					whileHover={animations.hover}
					whileTap={animations.tap}
					onClick={() => {
						onNextClick();
					}}
				>
					<Icon name={'arrow-right'} color={iconColor} />
				</motion.button>
			)}
		</div>
	);
}

interface NavigationBarProps {
	onNextClick: Function;
	onPrevClick: Function;
	classNames?: Array<string>;
	labels?: {
		prevLabel?: string;
		nextLabel?: string;
	};
	disable: {
		left: boolean;
		right: boolean;
	};
}
